import axiosInstance from "../axios.service"
import BaseUrl from "../url.service"

const serverUrl = `${BaseUrl}/webWhyChoose`

console.log('serverUrl', serverUrl)

export const addWhyChooseUsApi = (formData) => {
    return axiosInstance.post(`${serverUrl}/addOrUpdateWebWhyChoose`, formData)
}

export const getWhyChooseUsApi = (query = "") => {
    return axiosInstance.get(`${serverUrl}/getWhyChoose`)
}

const WhyChooseUsService = {
    addWhyChooseUs: addWhyChooseUsApi,
    getWhyChooseUss: getWhyChooseUsApi
}

export default WhyChooseUsService
